'use client';
import React from 'react';

import { GoogleIcon } from '@/assets/icons/external';
import { useGoogleLogin } from '@react-oauth/google';
import CalendarFeatureService from '@/services/util/calendar-feature-service';
import UtilityService from '@/services/util/utility-service';

const redirect_uri =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_API_URL_DEVELOPMENT
    : UtilityService.getApiUrl();

interface Props {
  isAdmin?: boolean;
  isSAML?: boolean;
}

function GoogleLoginButton({ isAdmin = false, isSAML = true }: Props): React.JSX.Element {
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    include_granted_scopes: false,
    overrideScope: true,
    ux_mode: 'redirect',
    redirect_uri: `${redirect_uri}auth/${isAdmin ? 'admin/' : ''}login`,
    scope: CalendarFeatureService.getGoogleLoginScope(),
    state: JSON.stringify({ origin: window.location.origin }),
  });
  const SAMLLogin = (e: any) => {
    window.location.href = `${redirect_uri}auth/saml/login`;
  };

  return (
    <>
      <button
        onClick={isSAML && !isAdmin ? SAMLLogin : googleLogin}
        className='bg-white font-medium text-neutral-800 inline-flex items-center justify-center whitespace-nowrap rounded-2xl shadow-sm border border-slate-200 px-4 py-3 w-full max-w-none'
      >
        <div className='w-[30px] h-[30px] mr-2 flex items-center justify-center'>
          <GoogleIcon />
        </div>
        Sign in with Google
      </button>
    </>
  );
}

export default GoogleLoginButton;
